export const ACCRUALS_IM_SELECTION_IN_PROGRESS = ['queued', 'matching', 'creating'];
export const ACCRUALS_COMPUTATION_IN_PROGRESS = ['queued', 'matching', 'claiming', 'computing'];

export const ACCRUALS_RUN_POLL_MS = 4000;
export const ACCRUALS_RUN_POLL_MAX = 90;

const IM_COUNT_ENTRIES = [
  ['matched', 'matched'],
  ['created', 'created'],
  ['missing_owner', 'missing owner'],
  ['failed', 'failed'],
];

const COMPUTATION_COUNT_ENTRIES = [
  ['matched', 'matched'],
  ['claimed', 'claimed'],
  ['calculated', 'calculated'],
  ['skipped_claimed', 'already claimed'],
  ['skipped_po_reserved', 'PO reserved'],
  ['skipped_reason', 'skipped'],
  ['failed', 'failed'],
];

export function isAccrualsImSelectionInProgress(status) {
  return ACCRUALS_IM_SELECTION_IN_PROGRESS.includes(status);
}

export function isAccrualsComputationInProgress(status) {
  return ACCRUALS_COMPUTATION_IN_PROGRESS.includes(status);
}

export function formatRunCountsLabel(counts, entries) {
  if (!counts || typeof counts !== 'object') return '';
  return entries
    .map(([key, label]) => {
      const value = counts[key];
      if (typeof value !== 'number' || value <= 0) return null;
      return `${value} ${label}`;
    })
    .filter(Boolean)
    .join(' · ');
}

export function formatImSelectionRunMeta(run) {
  const status = run?.status;
  if (!status || status === 'not_started') return '';
  const counts = formatRunCountsLabel(run.counts, IM_COUNT_ENTRIES);
  return counts ? `Run ${status} · ${counts}` : `Run ${status}`;
}

export function formatComputationRunMeta(run) {
  const status = run?.status;
  if (!status || status === 'not_started') return '';
  const counts = formatRunCountsLabel(run.counts, COMPUTATION_COUNT_ENTRIES);
  return counts ? `Run ${status} · ${counts}` : `Run ${status}`;
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function pollAccrualsRun({
  fetchStatus,
  isInProgress,
  intervalMs = ACCRUALS_RUN_POLL_MS,
  maxAttempts = ACCRUALS_RUN_POLL_MAX,
  shouldStop = () => false,
}) {
  let last = null;
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    if (shouldStop()) return last;
    last = await fetchStatus();
    if (!isInProgress(last?.status)) return last;
    await delay(intervalMs);
  }
  return last;
}
